import AbsolutePane from './_absolute-pane.js'
import ImageButton from './_image-button.js'

export default {
  name: 'RemoveSelection',
  values: {
    removeSelectionButtonContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          left: '-8px',
          top: '-8px',
        },
      },
    },
    removeSelectionButton: {
      configSet: ImageButton,
      configValues: {
        innerContainer: {
          style: {
            padding: '12px 0 0 0',
          },
        },
        button: {
          style: {
            base: {
              minWidth: '32px',
              minHeight: '40px',
            },
          },
        },
        buttonIcon: {
          src: 'close-thin',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
